/**
 * forceNumeric() plug-in implementation
 */
jQuery.fn.forceNumeric = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.which || e.keyCode;

            if (
                // !e.shiftKey && !e.altKey && !e.ctrlKey &&
                !e.shiftKey && !e.altKey && !e.ctrlKey &&
            // cut
                (e.ctrlKey || e.metaKey && key == 88) ||
            // copy
                (e.ctrlKey || e.metaKey && key == 67) ||
            // paste
                (e.ctrlKey || e.metaKey && key == 86) ||
            // numbers
                key >= 48 && key <= 57 ||
            // Numeric keypad
                key >= 96 && key <= 105 ||
            // Backspace, Tab and Enter
               key == 8 || key == 9 || key == 13 ||
            // Home and End
               key == 35 || key == 36 ||
            // left and right arrows
               key == 37 || key == 39 ||
            // Del and Ins
               key == 46 || key == 45)
                return true;

            return false;
        });
    });
}


/**
 *
 */
jQuery.fn.forceNumericExtended = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.which || e.keyCode;

            if (
                // !e.shiftKey && !e.altKey && !e.ctrlKey &&
                !e.shiftKey && !e.altKey && !e.ctrlKey &&
            // cut
                (e.ctrlKey || e.metaKey && key == 88) ||
            // copy
                (e.ctrlKey || e.metaKey && key == 67) ||
            // paste
                (e.ctrlKey || e.metaKey && key == 86) ||
            // numbers
                key >= 48 && key <= 57 ||
            // Numeric keypad
                key >= 96 && key <= 105 ||
            // period and minus, . on keypad
               key == 188 || key == 109 || key == 173 || key == 110 ||  key == 190 ||
            // Backspace, Tab and Enter
               key == 8 || key == 9 || key == 13 ||
            // Home and End
               key == 35 || key == 36 ||
            // left and right arrows
               key == 37 || key == 39 ||
            // Del and Ins
               key == 46 || key == 45)
                return true;

            return false;
        });
    });
}

/**
 *
 */
jQuery.fn.forceNumericTime = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.which || e.keyCode;

            if (
                // !e.shiftKey && !e.altKey && !e.ctrlKey &&
                !e.shiftKey && !e.altKey && !e.ctrlKey &&
            // cut
                (e.ctrlKey || e.metaKey && key == 88) ||
            // copy
                (e.ctrlKey || e.metaKey && key == 67) ||
            // paste
                (e.ctrlKey || e.metaKey && key == 86) ||
            // numbers
                key >= 48 && key <= 57 ||
            // Numeric keypad
                key >= 96 && key <= 105 ||
            // :, a, m, p and space
               key == 59 || key == 186 || key == 65 || key == 80 || key == 77 || key == 32 ||
            // Backspace, Tab and Enter
               key == 8 || key == 9 || key == 13 ||
            // Home and End
               key == 35 || key == 36 ||
            // left and right arrows
               key == 37 || key == 39 ||
            // Del and Ins
               key == 46 || key == 45)
                return true;

            return false;
        });
    });
}